import { apiBase, getTokens } from '../api';

export type ClientErrorSource =
  | 'error-boundary'
  | 'window.onerror'
  | 'unhandledrejection'
  | 'manual';

/**
 * Report a client crash to the server's intake (`POST /v1/client-errors`).
 * Best-effort by contract: never throws, never retries, never blocks the
 * UI, and silently no-ops when there is no session (a crash on the sign-in
 * page has nobody to attribute it to — the console still has it). Uses
 * raw fetch rather than the api() helper because the helper itself may be
 * the thing that is broken, and error reporting must not recurse.
 */
export function reportClientError(source: ClientErrorSource, error: unknown): void {
  try {
    const tokens = getTokens();
    if (!tokens) return;
    const message = error instanceof Error ? error.message : String(error);
    const stack = error instanceof Error ? error.stack : undefined;
    void fetch(`${apiBase()}/v1/client-errors`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${tokens.access_token}`,
      },
      body: JSON.stringify({
        source,
        message: message.slice(0, 500),
        stack: stack?.slice(0, 4000),
        url: window.location.pathname,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch {
    // The reporter never becomes the next error.
  }
}
